module.exports = __webpack_public_path__ + "img/left.c823e0e7.svg";